import type { IEvent } from '../../';

export const hasSearchTerm = (searchTerm: string) => Boolean(searchTerm?.trim().length > 0);

export const filterBySearchTerm = (searchTerm: string) => (event: IEvent) =>
	hasSearchTerm(searchTerm) ? event.title.toLowerCase().includes(searchTerm.toLowerCase()) : true;
